import { useDispatch, useSelector } from 'react-redux';
import { selectLocale } from '@/store/selectors/commonSelectors';
import { useEffect } from 'react';
import { getHeroBackgrounds } from '@/store/cms/hero-backgrounds/actions';

export const useHeroBackgroundsLoader = () => {
  const locale = useSelector(selectLocale);
  const dispatch = useDispatch();

  useEffect(() => {
    if (!locale) {
      return;
    }

    dispatch(getHeroBackgrounds());
  }, [locale]);
};
